export function LaunchGuideIcon() {
    return (
        <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M10.5827 13.0833V18.9167C10.5827 19.8371 9.83649 20.5833 8.91601 20.5833H3.08268C2.16221 20.5833 1.41602 19.8371 1.41602 18.9167V6.41667C1.41602 5.49619 2.16221 4.75 3.08268 4.75H6.41602"
                stroke="var(--mantine-color-dark-3)"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M20.582 7.66699C20.582 8.35735 20.0224 8.91699 19.332 8.91699H14.7487L12.2487 11.417V8.91699H9.33203C8.64168 8.91699 8.08203 8.35735 8.08203 7.66699V2.66699C8.08203 1.97664 8.64168 1.41699 9.33203 1.41699H19.332C20.0224 1.41699 20.582 1.97664 20.582 2.66699V7.66699Z"
                stroke="var(--mantine-color-dark-3)"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M14.5404 4.75C14.4253 4.75 14.332 4.84327 14.332 4.95833C14.332 5.07339 14.4253 5.16667 14.5404 5.16667C14.6554 5.16667 14.7487 5.07339 14.7487 4.95833C14.7487 4.84327 14.6554 4.75 14.5404 4.75"
                stroke="var(--mantine-color-dark-3)"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M17.4583 4.75C17.3433 4.75 17.25 4.84327 17.25 4.95833C17.25 5.07339 17.3433 5.16667 17.4583 5.16667C17.5734 5.16667 17.6667 5.07339 17.6667 4.95833C17.6667 4.84327 17.5734 4.75 17.4583 4.75"
                stroke="var(--mantine-color-dark-3)"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M11.6243 4.75C11.5093 4.75 11.416 4.84327 11.416 4.95833C11.416 5.07339 11.5093 5.16667 11.6243 5.16667C11.7394 5.16667 11.8327 5.07339 11.8327 4.95833C11.8327 4.84327 11.7394 4.75 11.6243 4.75"
                stroke="var(--mantine-color-dark-3)"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}
